import OP3Dialog from "../General/Dialog";
import OP3Form from "../General/Form";
import $ from 'jquery';

export default class Integrations {
    constructor() {
        /**
         * Service jquery-confirm dialog
         *
         * @type {$.confirm}
         */
        this.addNewServiceIntegrationConfirm = null;

        /**
         * Edit integration jquery-confirm dialog
         *
         * @type {$.confirm}
         */
        this.editIntegrationConfirm = null;

        let _this = this;
        $(() => {
            $('.opd-add-new-service-integration-btn').on('click', _this.addNewServiceIntegrationBtnClick.bind(_this));
            $('.opd-edit-integration-btn').on('click', _this.editIntegrationBtnClick.bind(_this));
            $('.js-disconnect-integration-connection').on('click', _this.integrationDisconnectBtnClick.bind(_this));

            $('body')
                .on('click', '.opd-integration-enter-credentials-btn, .opd-integration-enter-oauth-credentials-btn', _this.openEnterCredentialsBtnClick.bind(_this))
                .on('click', '[data-opd-integration-action="clean-credentials"]', _this.clearIntegrationCredentialsClick.bind(_this))
                .on('submit', '.opd-integration-enter-credentials-form', _this.formCredentialsSubmit.bind(_this))
                .on('click', '.opd-integration-enter-oauth-credentials-form-submit-btn', _this.submitEnterOAuthCredentialsClick.bind(_this))

        });
    } 

    /**
     * Opening Dialog once user wants to add new integration
     *
     * @param {Object} e
     * @return {Void}
     */
    addNewServiceIntegrationBtnClick(e) {
        e.preventDefault();

        if (!OP3General.checkLicense())
            return;

        let confirmTitle = $(e.currentTarget).data('title');

        this.addNewServiceIntegrationConfirm = $.dialog(Object.assign(OP3Dialog.dialogOptions, {
            theme: 'optimizepress,optimizepress-mini,op-dashboard-add-integration',
            title: OP3Dialog.headerWithFilter(confirmTitle),
            content: () => {
                return $.post(
                    OpsScriptData.ajax_url,
                    {
                        'action': 'opd_addIntegration',
                    },
                    (response) => {
                        this.addNewServiceIntegrationConfirm.setContent(response);
                    }
                )
            },
            onContentReady: () => {
                this.filterContent('.op3-input-filter', '.opd-dashboard-integrations-list-item', 'h4');
            }
        }));
    }

    /**
     * Opening Dialog once user wants to add new integration
     *
     * @param {Object} e
     * @return {Void}
     */
    editIntegrationBtnClick(e) {
        e.preventDefault();

        let $this = $(e.currentTarget);
        let providerTitle = $this
            .closest('.opd-connected-integration-item')
            .find('.opd-integration-title')
            .text();

        this.editIntegrationConfirm = $.dialog(Object.assign(OP3Dialog.dialogOptions, {
            theme: 'optimizepress,optimizepress-mini,op-dashboard-integration-item-edit',
            title: `${$this.text()} - ${providerTitle}`,
            content: () => {
                return $.post(
                    OpsScriptData.ajax_url,
                    {
                        action: 'opd_editIntegration',
                        provider: $this.data('provider')
                    },
                    (response) => {
                        this.editIntegrationConfirm.setContent(response);
                    }
                )
            },
            onContentReady: () => {
                let $content = this.editIntegrationConfirm.$content;

                $content.find('.opd-integration-enter-credentials-form-submit-btn').text($this.text());
                $content.find('.opd-integration-enter-oauth-credentials-form-submit-btn').text($this.text());
            }
        }));
    }

    /**
     * Filtering content based on input selector, 
     * search element and search string
     *
     * @param {string} selector 
     * @param {string} searchHaystack
     * @param {string} searchNeedle
     */
    filterContent(selector, searchHaystack, searchNeedle) {
        let $jconfirmTitle = $('.jconfirm-title');
        let $jconfirmContent = $('.jconfirm-content');

        $jconfirmTitle
            .find(selector)
            .on('keyup', (e) => {
                let $input = $(e.currentTarget);
                let searchText = String($input.val()).toLocaleLowerCase();
                $jconfirmContent.find(searchHaystack).each((index, element) => {
                    let $element = $(element);
                    let elementText = String($element.find(searchNeedle).html()).toLocaleLowerCase();

                    (elementText.indexOf(searchText) !== -1) ? $element.removeClass('opd-hide') : $element.addClass('opd-hide');
                });
            })
            .trigger('focus');
        ;
    }

    /**
     * Open form for editing credentials 
     *
     * @param {Object} e
     * @returns {Void}
     */
    openEnterCredentialsBtnClick(e) {
        e.preventDefault();

        // Close other open integrations
        $('.opd-dashboard-integrations-list-item')
            .removeClass('opd-open');

        $(e.currentTarget)
            .closest('.opd-dashboard-integrations-list-item')
            .addClass('opd-open');
    }

    /**
     * Submit form with integration credentials
     *
     * @todo - Add action url and calls to AJAX for saving integrations
     * 
     * @param {Object} e
     * @return {Void}
     */
    formCredentialsSubmit(e) {
        let $form = $(e.currentTarget);
        let url = $form.data("action-url");
        let data = $form.find('input').serialize();

        $.ajax({
            url: url,
            data: data,
            method: 'post',
            dataType: 'json',
        }).done(function(response) {
            window.OPDashboard.Helpers.notify(response.message, "success");

            if ($form.data('redirectUrl')) {
                window.location.replace($form.data('redirectUrl'));
            } else {
                location.reload();
            }
        }).fail(function(response) {
            window.OPDashboard.Helpers.notify(response.responseJSON.message, "error");
        });

        return false;
    }

    /**
     * Save credential for OAuth connections
     *
     * @param {Object} e
     * @returns {Void}
     */
     submitEnterOAuthCredentialsClick(e) {
        e.preventDefault();

        let $this = $(e.currentTarget);
        let $integrationEnterCredentialsForm = $this.closest('.opd-integration-enter-oauth-credentials-form');
        let $saveButton = $('.opd-integration-enter-oauth-credentials-form-submit-btn');
        let saveText = $saveButton.html();
        let $oauthActionContainer = $this.closest('.oauth-connection-actions');
        let $connectButton = $oauthActionContainer.find('.opd-integration-connect-choose');
        let url = $integrationEnterCredentialsForm.data("action-url");
        let data = $integrationEnterCredentialsForm.find('input').serialize();

        $saveButton.stop().fadeTo(100, .5).attr('disabled', 'disabled').addClass('ops-disabled').text('Saving...');

        let formObject = new OP3Form($);

        formObject.on('OP3Form:postRequest', (result, $form, url, data) => {
            $saveButton.stop().fadeTo(100, 1).removeAttr('disabled').removeClass('ops-disabled').html(saveText);

            if (result.success) {
                $oauthActionContainer.addClass('opd-connection-actions-for-connected');
                $connectButton.attr('href', result.authorization_url);
                window.OPDashboard.Helpers.notify(result.message, "success");
            } else {
                window.OPDashboard.Helpers.notify(result.message, "error");
            }
        });

        formObject.postRequest($integrationEnterCredentialsForm, url, data);
    }

    /**
     * Clear integration saved credentials.
     * Problem was with direct oAuth integrations,
     * if wrong credentials was saved, user couldn't
     * change them.
     * @see direct_oauth in vendor/optimizepress/integrations
     * 
     * @param {Object} e
     * @returns {Void}
     */
    clearIntegrationCredentialsClick(e) {
        let $this = $(e.currentTarget);
        let $integrationListItem = $this.closest('.opd-dashboard-integrations-list-item');

        if (!$integrationListItem.attr("data-opd-direct-oauth"))
            return;

        let provider = $integrationListItem.attr("data-opd-integration");

        $.post({
            url: OpsScriptData.ajax_url,
            data: {
                action: 'opd_disconnect_integration',
                nonce: OpsScriptData.nonce,
                provider: provider,
            }
        }).done(function(result) {
            if (!result.success)
                return;

            window.OPDashboard.Helpers.notify("Credentials deleted", "success");
            $integrationListItem
                .find(':input:not([readonly])')
                .val("");
        }).fail(function(response) {
            window.OPDashboard.Helpers.notify("Error while deleting credentials", "error");
        });
    }

    /**
     * Integration disconnect button click event handler.
     * 
     * @param {Object} e
     * @returns {Void}
     */
    integrationDisconnectBtnClick(e) {
        let $el = $(e.currentTarget);
        let confirmMessage = $el.data("confirm");
        let provider = $el.data("provider");

        if (confirm(confirmMessage)) {
            $.post({
                url: OpsScriptData.ajax_url,
                data: {
                    action: 'opd_disconnect_integration',
                    nonce: OpsScriptData.nonce,
                    provider: provider,
                }
            }).done(function( result ) {
                if (!result.success)
                    return;

                window.OPDashboard.Helpers.notify(result.message, "success");

                setTimeout(function() {
                    window.top.location.href = window.top.location.href;
                }, 1000);
            });
        }

        return false;
    };
}